"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorLink = void 0;
const core_1 = require("@apollo/client/core");
const xstate_1 = require("xstate");
const auth_machine_1 = require("../auth-machine/auth-machine");
const user_policy_1 = require("./local-state/user/user.policy");
const error_1 = require("@apollo/client/link/error");
const createAuthService = (context) => {
    return (0, xstate_1.interpret)(auth_machine_1.authMachine.withContext(context));
};
/**
 * This file has grown to a point where it needs a refactor.
 */
let cache;
let providedConfig;
let stateMachine;
const config = () => {
    if (providedConfig) {
        return providedConfig;
    }
    else if (window.snapApolloConfig) {
        return window.snapApolloConfig;
    }
    else {
        throw new Error("App tried to initialize without an Apollo Config");
    }
};
const setCache = (inMemoryCache) => {
    cache = inMemoryCache;
};
const createApolloLink = (requestHandler) => {
    return new core_1.ApolloLink(requestHandler);
};
const constructClient = (options) => {
    return new core_1.ApolloClient(options);
};
const localTypeDefs = (consumerTypeDefs) => {
    const { includeLocalSchema } = clientTools.config();
    if (includeLocalSchema !== true || !consumerTypeDefs) {
        return;
    }
    //still trying to figure out an intuative way to do this with .graphql files
    return consumerTypeDefs;
};
const createHttpLink = (options) => {
    return new core_1.HttpLink(options);
};
const hasGraphQLError = (graphQLErrors = [], code) => graphQLErrors.find((error) => { var _a; return ((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code) === code; }) !== undefined;
exports.errorLink = (0, error_1.onError)(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
        if (hasGraphQLError(graphQLErrors, "FORBIDDEN")) {
            stateMachine.send({ type: "forceSignInEvent" });
        }
        return forward(operation);
    }
    if (networkError) {
        console.log(`[Network error]: ${networkError}`);
    }
});
const initializeCache = (consumerTypePolicies) => {
    clientTools.setCache(new core_1.InMemoryCache({
        typePolicies: Object.assign(Object.assign({}, user_policy_1.localUserTypePolicy), (!!consumerTypePolicies && consumerTypePolicies)),
    }));
};
const getClient = (apolloConfig, consumerTypePolicies, consumerTypeDefs) => {
    clientTools.initializeCache(consumerTypePolicies);
    if (!!apolloConfig) {
        window.snapApolloConfig = apolloConfig;
        providedConfig = apolloConfig;
    }
    const localTypeDefs = clientTools.localTypeDefs(consumerTypeDefs);
    const redirectLocation = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const consumer = urlParams.get("consumer") || undefined;
    const { ssoHost, redirectTo = redirectLocation, forceAuthentication, name, version, } = clientTools.config();
    const apolloClient = clientTools.constructClient(Object.assign(Object.assign(Object.assign({ link: clientTools.getConcattenatedLink(), cache: cache, connectToDevTools: true }, (!!localTypeDefs && { typeDefs: localTypeDefs })), (!!name && { name })), (!!version && { version })));
    stateMachine = clientTools.createAuthService({
        ssoHost,
        redirectTo,
        apolloClient,
        forceAuthentication,
        consumer,
    });
    stateMachine.start();
    window.__SNAP_APOLLO_CLIENT__ = apolloClient;
    const authFailedEvent = {
        type: "authFailedEvent",
    };
    window.addEventListener("snap-user-logout", () => {
        stateMachine.send(authFailedEvent);
    });
    const authForceEvent = { type: "forceAuthEvent" };
    return [apolloClient, () => stateMachine.send(authForceEvent)];
};
const getConcattenatedLink = () => {
    const { graphqlUrl } = clientTools.config();
    return clientTools
        .createApolloLink(clientTools.apolloLinkRequestHandler)
        .concat(exports.errorLink)
        .concat(clientTools.createHttpLink({
        uri: graphqlUrl,
        credentials: "include",
    }));
};
//todo: delete me
const apolloLinkRequestHandler = (operation, forward) => {
    return forward(operation);
};
const clientTools = {
    localTypeDefs,
    getClient,
    constructClient,
    createAuthService,
    createHttpLink,
    apolloLinkRequestHandler,
    createApolloLink,
    getConcattenatedLink,
    initializeCache,
    setCache,
    config,
};
exports.default = clientTools;
